/* =============================================================================
   CONFIGURACIÓN GLOBAL DEL SITIO
   -----------------------------------------------------------------------------
   Datos que se repiten en todas las páginas: dominio, teléfonos, dirección.
   Cambiar aquí una vez y se actualiza en toda la web y en el sitemap.
   ============================================================================= */

const SITE = {
  dominio: 'https://gestoriariola.com',
  nombre: 'Gestoría Riola',
  razonSocial: 'Gestoría Riola',
  fundacion: 1935,

  telefono: '+34639086934',
  telefonoTexto: '639 086 934',

  // Teléfono de seguros: el silo de seguros muestra este, no el general
  telefonoSeguros: '+34624217274',
  telefonoSegurosTexto: '624 21 72 74',

  // WhatsApp: seguros va al número de Alex, el resto al general
  whatsapp: '34639086934',
  whatsappSeguros: '34624217274',

  email: 'riola@gestoriariola.com',

  /* -----------------------------------------------------------------------
     ANTISPAM — Cloudflare Turnstile
     Pegar aquí la Site Key del widget (dashboard de Cloudflare > Turnstile).
     Mientras esté vacía, el captcha no se pinta y los formularios funcionan
     igual que siempre. El Secret Key NO va aquí: va en los ajustes del
     formulario en Formspree, que es quien valida el token.
     -------------------------------------------------------------------- */
  turnstileSiteKey: '',

  /* -----------------------------------------------------------------------
     ANALITICA
     Los dos scripts (Google Analytics 4 y Microsoft Clarity) NO se cargan
     hasta que el usuario acepta en el banner de cookies. Lo gestiona
     src/plugins/consentimiento.js. Si un ID esta vacio, ese servicio no se
     carga nunca, ni aunque el usuario acepte.
     El ID de Clarity se saca de clarity.microsoft.com > Settings > Setup.
     -------------------------------------------------------------------- */
  analitica: {
    ga4Id: 'G-TV7ZG2M8GW',
    clarityProjectId: 'yemlrr5elr'
  },

  direccion: {
    calle: 'Rambla Nova, 110, 2º 2ª',
    codigoPostal: '43001',
    ciudad: 'Tarragona',
    provincia: 'Tarragona',
    comunidad: 'Cataluña',
    pais: 'ES'
  },

  geo: {
    lat: 41.1189,
    lng: 1.2445
  },

  // Ámbito geográfico que declaramos en los datos estructurados
  areaServicio: [
    'Tarragona',
    'Reus',
    'Valls',
    'Cambrils',
    'Salou',
    'El Vendrell',
    'Tortosa',
    'Provincia de Tarragona'
  ]
};

/* -----------------------------------------------------------------------------
   IDIOMAS
   El castellano cuelga de la raíz ( / ) y el catalán de /cat
   -------------------------------------------------------------------------- */
const IDIOMAS = {
  es: {
    codigo: 'es',
    hreflang: 'es-ES',
    prefijo: '',
    nombre: 'Castellano'
  },
  ca: {
    codigo: 'ca',
    hreflang: 'ca-ES',
    prefijo: '/cat',
    nombre: 'Català'
  }
};

module.exports = { SITE: SITE, IDIOMAS: IDIOMAS };
module.exports.default = SITE;
